/**
 * @generated SignedSource<<2c67a0fa529ea8de88016194dd457f51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATSuperSignInInput = {
  email: any;
};
export type OrganizationId_superSignInMutation$variables = {
  input: MATSuperSignInInput;
};
export type OrganizationId_superSignInMutation$data = {
  readonly superSignIn: string;
};
export type OrganizationId_superSignInMutation = {
  response: OrganizationId_superSignInMutation$data;
  variables: OrganizationId_superSignInMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "superSignIn",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganizationId_superSignInMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrganizationId_superSignInMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f67d7e16e649fcb18297def35519096c",
    "id": null,
    "metadata": {},
    "name": "OrganizationId_superSignInMutation",
    "operationKind": "mutation",
    "text": "mutation OrganizationId_superSignInMutation(\n  $input: MATSuperSignInInput!\n) {\n  superSignIn(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "8d73c57a02fff7cb00d54480acc309fa";

export default node;
